<template>
  <div
    class="container m-auto text-gray-900 mt-6 text-center leading-loose tracking-wide"
  >
    <h1 class="text-center text-4xl">Claim the $ROYAL Airdrop</h1>
    <p class="text-xl mt-2" v-if="isConnected"></p>

    <div v-if="!isConnected">
      <ConnectWallet />
    </div>

    <div
      v-if="isConnected"
      class="flex flex-col px-6 md:px-0 w-full md:w-1/2 m-0 m-auto mt-6"
    >
      <div class="w-full">
        <div class="text-center text-xl">You will get: {{ amount }} $ROYAL</div>
      </div>

      <div class="flex md:flex-row justify-center flex-col -mx-3">
        <div class="px-3 w-full md:w-1/2">
          <button
            @click="getTokens"
            type="button"
            class="hover:bg-white hover:text-gray-900 focus:outline-none w-full border-2 border-gray-900 bg-gray-900 bg-opacity-100 text-white py-2 px-3 mt-6 text-md rounded-lg"
          >
            Get Tokens
          </button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import ConnectWallet from "@/components/ConnectWallet.vue";

const axios = require("axios").default;

export default {
  components: { ConnectWallet },
  data: function () {
    return {
      loader: false,
      leaf: null,
      proof: null,

      amount: 0,
      loaded: false,
      nodrop: true,
    };
  },
  computed: {
    isConnected: function () {
      return this.$store.state.web3 != null;
    },
  },
  watch: {
    isConnected: async function () {
      this.init();
    },
  },
  mounted: function () {
    this.init();
  },
  methods: {
    init: async function () {
      if (this.$store.state.web3 != null) {
        let data = await axios.get(
          "https://api.nft20.io/irdrap/" + this.$store.state.account
        );

        console.log(data);
        if (data.data != null) {
          this.nodrop = false;
          this.leaf = data.data.leaf_data;
          this.proof = JSON.parse(data.data.proof);
          this.amount = data.data.amount * 10;
        } else {
        }
        this.loaded = true;
      }
    },
    getTokens: async function () {
      try {
        if (this.vnftId == "") {
          this.$notify({
            group: "foo",
            title: "Input right parameters",
            text: `.`,
            type: "error",
          });
        } else {
          this.loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false,
            // onCancel: this.onCancel,
          });
          let addcaretaker = await this.$store.state.AirdropContract.methods
            .claim(this.leaf, this.proof)
            .send({
              from: this.$store.state.account,
            });
          this.loader.hide();
          alert(
            "Go to the play page and register your NFT to start participating in the game"
          );
          this.$notify({
            group: "foo",
            title: "Success",
            text: `You got the ${this.amount} $ROYAL.`,
            type: "success",
          });
        }
      } catch (e) {
        console.log(e);
        this.loader.hide();
        this.$notify({
          group: "foo",
          title: "Error",
          text: `There was an error with the tx`,
          type: "error",
        });
      }
    },
  },
};
</script>